module.exports = __webpack_public_path__ + "static/og-image-2b0a358ab5e7e957322561ba2f3d4618.png";